<div 
  class="skeleton"
  [class.skeleton--full-round]="fullRound()"
  [style.height]="height()"
  [style.width]="width() === 'auto' ? null : width()"
></div> 